module.exports = __webpack_public_path__ + "static/img/68.96bf5dd0.gif";